module.exports = __webpack_public_path__ + "static/media/dotted.a4ad4b17.svg";